// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { BrandedLayout } from '../components/layouts/branded-layout';
import { InfoBlock } from '../components/ui/info-block';
import { cleanPhone } from '../utils/phone';

export function InviteExpired() {
  const { inviteId } = useParams();
  const { t } = useTranslation('page.invite-expired');

  return (
    <BrandedLayout>
      <h1 className="title text-error-500">{t('title')}</h1>
      <InfoBlock>
        <Trans
          i18nKey="text"
          t={t}
          values={{ ...brand, inviteId }}
          components={{
            h3: <h3 className="subtitle mb-0" />,
            p: <p />,
            br: <br />,
            em: <span className="uppercase" />,
            strong: <strong className="font-semibold" />,
            a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
          }}
        />
      </InfoBlock>
    </BrandedLayout>
  );
}
